export class InvoiceLine {
    id: string;
    invoiceId: string;
    price: string;
    discount: string;
    total: string;
    details: string;

    constructor() {
        this.id = '';
        this.price = '';
        this.details = '';
        this.discount = '';
        this.total = '';
    }
}
